export default __webpack_public_path__ + "static/media/ico-elastic-cache-score-moderate.8e1f39ca.svg";